/** Original WorldBet24 marks: a globe ring with an orbit and a "24" tile (admin console). */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="wb24g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#22e5b4" />
          <stop offset="1" stopColor="#8b7bff" />
        </linearGradient>
      </defs>
      <circle cx="30" cy="32" r="22" fill="none" stroke="url(#wb24g)" strokeWidth="5" />
      <ellipse cx="30" cy="32" rx="9" ry="22" fill="none" stroke="url(#wb24g)" strokeWidth="3" opacity="0.85" />
      <path d="M9 24h42M9 40h42" stroke="url(#wb24g)" strokeWidth="3" opacity="0.6" />
      <rect x="36" y="36" width="26" height="22" rx="6" fill="#ffb02e" />
      <text x="49" y="52" textAnchor="middle" fontFamily="system-ui, sans-serif" fontWeight="900" fontSize="13" fill="#2b1a00">
        24
      </text>
    </svg>
  );
}

/**
 * Customer-site wordmark: plain bold white "WorldBet24". Without `size` the font size comes from
 * the surrounding CSS (`.wb-wordmark`).
 */
export function Wordmark({ size }: { size?: number }) {
  return (
    <span
      className="wb-wordmark"
      style={{
        ...(size ? { fontSize: size } : {}),
        fontWeight: 900,
        letterSpacing: "-0.045em",
        lineHeight: 1,
        whiteSpace: "nowrap",
        color: "var(--bw-text)",
      }}
    >
      WorldBet24
    </span>
  );
}
